import { Grid, Tooltip, Typography } from '@mui/material'
import { NOT_APPLICABLE, STANDARD_DATE_FORMAT } from '../../constants'
import moment from 'moment'
import { ExternalUser } from '../../../generated'
import { formatPhoneHyphenated, removeCountryCodeFromExternalUserPhone } from '../../utils'

export const renderFieldData = (value: string) => (
  <Tooltip title={value} placement="bottom-start">
    <Typography fontSize="16px" variant="h6" sx={{ fontWeight: 'normal' }} noWrap>
      {value}
    </Typography>
  </Tooltip>
)

export const CommonExternalUserView = ({
  externalUser,
  isJudge = false
}: {
  externalUser: ExternalUser
  isJudge?: boolean
}) => {
  const {
    firstName,
    middleName,
    lastName,
    displayName,
    businessName,
    suffix,
    initials,
    dateOfBirth,
    phoneNumber,
    homePhone,
    personalPhone,
    phoneNumberExtension,
    email
  } = externalUser ?? {}

  return (
    <>
      <Grid item md={4} sm={12} xs={12}>
        <Typography variant="body2" fontSize="14px">
          Name:
        </Typography>
        <Tooltip
          title={displayName || NOT_APPLICABLE}
          placement="bottom-start"
        >
          <Typography
            variant="h6"
            fontSize="16px"
            noWrap
            sx={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis' }}
          >
            {displayName || NOT_APPLICABLE}
          </Typography>
        </Tooltip>
      </Grid>

      {businessName != null && businessName !== '' && (
        <Grid item md={4} sm={12} xs={12}>
          <Typography variant="body2" fontSize="14px">
            Business Name:
          </Typography>
          {renderFieldData(businessName)}
        </Grid>
      )}

      <Grid item md={4} sm={12} xs={12}>
        <Typography variant="body2" fontSize="14px">
          Initials:
        </Typography>
        {renderFieldData(initials || NOT_APPLICABLE)}
      </Grid>

      <Grid item md={4} sm={12} xs={12}>
        <Typography variant="body2" fontSize="14px">
          Date of Birth:
        </Typography>
        {renderFieldData(dateOfBirth ? `${moment(dateOfBirth).format(STANDARD_DATE_FORMAT)}` : '--')}
      </Grid>

      {isJudge ? (
        <>
          <Grid item md={4} sm={12} xs={12}>
            <Typography variant="body2" fontSize="14px">
              Phone #:
            </Typography>
            {renderFieldData(removeCountryCodeFromExternalUserPhone(phoneNumber || NOT_APPLICABLE))}
          </Grid>

          <Grid item md={4} sm={12} xs={12}>
            <Typography variant="body2" fontSize="14px">
              Phone Extension:
            </Typography>
            {renderFieldData(phoneNumberExtension || NOT_APPLICABLE)}
          </Grid>
        </>
      ) : (
        <>
          <Grid item md={4} sm={12} xs={12}>
            <Typography variant="body2" fontSize="14px">
              Work Phone:
            </Typography>
            {formatPhoneHyphenated(removeCountryCodeFromExternalUserPhone(homePhone || NOT_APPLICABLE))}
          </Grid>
          <Grid item md={4} sm={12} xs={12}>
            <Typography variant="body2" fontSize="14px">
              Home Phone:
            </Typography>
            {formatPhoneHyphenated(removeCountryCodeFromExternalUserPhone(personalPhone || NOT_APPLICABLE))}
          </Grid>
          <Grid item md={4} sm={12} xs={12}>
            <Typography variant="body2" fontSize="14px">
              Personal Phone:
            </Typography>
            {formatPhoneHyphenated(removeCountryCodeFromExternalUserPhone(personalPhone || NOT_APPLICABLE))}
          </Grid>
        </>
      )}

      <Grid item md={12} sm={12} xs={12}>
        <Typography variant="body2" fontSize="14px">
          Email:
        </Typography>
        {renderFieldData(email || NOT_APPLICABLE)}
      </Grid>
    </>
  )
}
